import { Alert, Button, Drawer, Field, Input } from '@itds/elements/index.js';
import React, { useEffect, useState } from 'react';

import { Api } from '@carrier/utils/Api';
import { Colors } from '@itds/Theme';
import FormUtils from '@itds/utils/Form';
import { PASSWORD_RULES } from '@itds/Constants';
import PropTypes from 'prop-types';

const Edit = ({ admin, onClose, onSave, show }) => {
  const styles = {
    password_rule: {
      marginBottom: 10
    },
    password_rule_valid: {
      color: '#999'
    },
    icon: {
      fontSize: 20,
      verticalAlign: 'middle',
      color: '#ccc',
      marginRight: 2
    },
    icon_green: {
      fontSize: 20,
      verticalAlign: 'middle',
      color: Colors.GREEN.hex,
      marginRight: 2
    }
  };
  const [input_fields, setInputFields] = useState({});
  const [errors, setErrors] = useState(['placeholder']);
  const [password_errors, setPasswordErrors] = useState([]);
  const [save_error, setSaveError] = useState(false);

  useEffect(() => {
    const new_admin = Object.assign({}, admin);

    setInputFields(new_admin);
  }, [admin]);

  const handleInputChange = (name, e) => {
    setInputFields({ ...input_fields, [name]: e.target.value });

    const errors = [];

    if (!FormUtils._validateEmail(input_fields.email)) {
      errors.push('email');
    }

    if (!admin.id && !input_fields.password) {
      errors.push('password');
    }

    setErrors(errors);

    if (name === 'password') {
      const password = e.target.value;
      const new_errors = [];

      PASSWORD_RULES.forEach(rule => {
        if (!rule.pattern.test(password)) {
          new_errors.push(rule.name);
        }
      });

      setPasswordErrors(new_errors);
    }
  };

  const handleSave = () => {
    Api.saveAdmin(admin.id, input_fields)
      .then(() => {
        onSave();
        setSaveError(false);
      })
      .catch(() => {
        setSaveError(true);
        setTimeout(() => {
          setSaveError(false);
        }, 2000);
      });
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button disabled={errors.length || password_errors.length} onClick={handleSave}>
          {admin && admin.id ? 'Save Changes' : 'Create New Admin'}
        </Button>
      }
      onClose={onClose}
      show={show}
      title={admin && admin.id ? `Editing ${admin.name}` : 'New Admin'}
    >
      {save_error ? (
        <Alert type='error'>An error occurred while trying to save the admin.</Alert>
      ) : null}

      <Field label='Email'>
        <Input
          invalid={errors.includes('email')}
          onChange={handleInputChange.bind(null, 'email')}
          value={input_fields.email}
        />
      </Field>
      <Field label='Password'>
        <Input
          invalid={(input_fields.password && password_errors.length) || errors.includes('password')}
          onChange={handleInputChange.bind(null, 'password')}
          type='password'
          value={input_fields.password}
        />
      </Field>
      {input_fields.password
        ? PASSWORD_RULES.map(rule => {
            const is_valid = !password_errors.includes(rule.name);

            return (
              <div
                key={rule.name}
                style={Object.assign(
                  {},
                  styles.password_rule,
                  is_valid && styles.password_rule_valid
                )}
              >
                {is_valid ? (
                  <i className='mdi mdi-checkbox-marked-circle-outline' style={styles.icon_green} />
                ) : (
                  <i className='mdi mdi-checkbox-blank-circle-outline' style={styles.icon} />
                )}{' '}
                {rule.label}
              </div>
            );
          })
        : null}
    </Drawer>
  );
};

Edit.propTypes = {
  admin: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default Edit;
